import $axios from '@/store/axios-instance.js';

export default {
    state: {
        settingData: null
    },
    mutations: {
        retrieveSettingData(state, entityList) {
            state.settingData = entityList
        },
    },
    actions: {
        retrieveSettingData(context) {
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .get('settings')
                        .then(response => {
                            context.commit('retrieveSettingData', response.data)
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        },
        setSettingData(context, payload){
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .post('settings', payload)
                        .then(response => {
                            context.commit('retrieveSettingData', {
                                localTimeOffset: payload.localTimeOffset,
                                delayedServiceNotificationOffset: payload.delayedServiceNotificationOffset,
                                serviceNumberSeries: {
                                    id: payload.serviceNumberSeriesId
                                },
                                clientTicketNumberSeries: {
                                    id: payload.clientTicketNumberSeriesId
                                }
                            })
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        }
    },
    getters: {
        settingData(state) {
            return state.settingData
        }
    }
}